<template>
  <v-data-table
    :headers="specialNeedDataTableHeaders"
    :items="specialNeedList"
    class="elevation-1"
    :loading="isLoadingSpecialNeed"
    :loading-text="$t('common_get_data')"
    :no-data-text="$t('common_no_data')"
    :no-results-text="$t('common_no_results')"
    :footer-props="{
      'items-per-page-options': [30, 50, 100],
      'items-per-page-text': $t('item_rows_per_page'),
    }"
    :header-props="headerProps"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('special_need_title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('point_search_label')"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <v-dialog v-model="isShowEditSpecialNeedDialog" max-width="800px" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2 ml-8"
              v-bind="attrs"
              v-on="on"
              :disabled="isAllTextFieldDisable"
            >
              {{ $t('common_new') }}
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ dialogTitleHeader }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <ValidationObserver ref="dialog">
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('special_need_name')"
                        :rules="{ required: true, is: isExist }"
                        v-slot="{ errors }"
                      >
                        <v-text-field v-model="specialNeedName" :error-messages="errors[0]">
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('special_need_name') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('special_need_is_auto_make_work')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-checkbox
                          v-model="editedSpecialNeed.IsAutoMakeWork"
                          :error-messages="errors[0]"
                          :label="$t('special_need_is_auto_make_work')"
                        >
                        </v-checkbox>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </ValidationObserver>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                @click="closeEditedSpecialNeed"
                :disabled="isAllTextFieldDisable"
              >
                {{ $t('common_cancel') }}
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="saveEditedSpecialNeed"
                :loading="isLoadingSaveBtn"
              >
                {{ $t('common_save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <delete-dialog
          :isAllTextFieldDisable="isAllTextFieldDisable"
          :isLoadingSaveBtn="isLoadingDeleteBtn"
          :isShowDeleteDialog="isShowDeleteSpecialNeedDialog"
          :deleteMessage="'common_delete'"
          @closeDelete="closeDeleteSpecialNeed"
          @confirmDelete="confirmDeleteSpecialNeed"
        />
      </v-toolbar>
    </template>
    <!-- <template v-slot:[`item.UpdateTime`]="{ item }">
      {{ convertToDateTimeFormat(item.UpdateTime) }}
    </template> -->
    <template v-slot:[`item.Type`]="{ item }">
      {{ turnFormType(item.Type) }}
    </template>
    <template v-slot:[`item.Edit`]="{ item }">
      <v-btn icon @click="isShowEditSpecialNeedBtn(item)">
        <v-icon small>
          mdi-pencil
        </v-icon>
      </v-btn>
      <v-btn icon @click="isShowDeleteSpecialNeedBtn(item)">
        <v-icon small>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { HttpSpecialNeed } from '@/js/http-Manager'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { extend } from 'vee-validate'
import { is } from 'vee-validate/dist/rules'

export default {
  name: 'SpecialNeed',
  components: { DeleteDialog },
  data: () => ({
    isShowEditSpecialNeedDialog: false,
    specialNeedList: [],
    editedSpecialNeedIndex: -1,
    search: '',
    editedSpecialNeed: {
      Name: '',
      IsAutoMakeWork: false
    },
    defaultSpecialNeed: {
      Name: '',
      IsAutoMakeWork: false
    },
    isLoadingSpecialNeed: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    isShowDeleteSpecialNeedDialog: false,
    isLoadingDeleteBtn: false,
    isDeleteBtnDisable: false,
    specialNeedName: '',
    isExist: false
  }),
  async mounted () {
    this.getSpecialNeed()
    extend('is', {
      ...is,
      message: '此名稱已重複'
    })
  },
  watch: {
    specialNeedName (val) {
      let tempIndex = this.specialNeedList.findIndex((x) => x.Name === val)
      this.isExist = tempIndex !== -1 && tempIndex !== this.editedSpecialNeedIndex
      if (!this.isExist) {
        this.editedSpecialNeed.Name = val
      }
    }
  },
  computed: {
    specialNeedDataTableHeaders () {
      return [
        {
          text: this.$t('special_need_name'),
          align: 'start',
          value: 'Name'
        },
        {
          text: this.$t('special_need_is_auto_make_work'),
          align: 'start',
          value: 'IsAutoMakeWork'
        },
        {
          text: this.$t('common_edit'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    dialogTitleHeader () {
      return this.editedSpecialNeedIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    }
  },
  methods: {
    async getSpecialNeed () {
      this.isLoadingSpecialNeed = true
      let response = await HttpSpecialNeed.GetSpecialNeed()
      this.isLoadingSpecialNeed = false
      this.specialNeedList = response.status === 200 ? response.data.Data : []
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditSpecialNeedBtn (item) {
      this.editedSpecialNeedIndex = this.specialNeedList.indexOf(item)
      this.editedSpecialNeed = JSON.parse(JSON.stringify(item))
      this.specialNeedName = item.Name
      this.isShowEditSpecialNeedDialog = true
    },
    closeEditedSpecialNeed () {
      this.isShowEditSpecialNeedDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.isLoadingSpecialNeed = false
      this.$nextTick(() => {
        this.editedSpecialNeed = JSON.parse(JSON.stringify(this.defaultSpecialNeed))
        this.editedSpecialNeedIndex = -1
        this.specialNeedName = ''
      })
    },

    async saveEditedSpecialNeed () {
      const isValid = await this.$refs.dialog.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        this.isLoadingSpecialNeed = true
        if (this.editedSpecialNeedIndex !== -1) {
          await HttpSpecialNeed.UpdateSpecialNeed(this.editedSpecialNeed)
        } else {
          await HttpSpecialNeed.AddSpecialNeed(this.editedSpecialNeed)
        }
        await this.getSpecialNeed()
        this.closeEditedSpecialNeed()
      }
    },
    isShowDeleteSpecialNeedBtn (item) {
      this.editedSpecialNeedIndex = this.specialNeedList.indexOf(item)
      this.isShowDeleteSpecialNeedDialog = true
    },
    async confirmDeleteSpecialNeed () {
      this.isLoadingDeleteBtn = true
      this.isDeleteBtnDisable = true
      this.isLoadingSpecialNeed = true
      await HttpSpecialNeed.UpdateSpecialNeedIsDelete(
        this.specialNeedList[this.editedSpecialNeedIndex].Id
      )
      this.isLoadingDeleteBtn = false
      this.isDeleteBtnDisable = false
      this.isLoadingSpecialNeed = false
      await this.getSpecialNeed()
      this.closeDeleteSpecialNeed()
    },

    closeDeleteSpecialNeed () {
      this.isShowDeleteSpecialNeedDialog = false
      this.$nextTick(() => {
        this.editedSpecialNeedIndex = -1
      })
    }
  }
}
</script>
